export default {
  upsert: 'modulesUpsert',
}
